import { render, staticRenderFns } from "./DesktopFloating.vue?vue&type=template&id=1be3f67c&"
import script from "./DesktopFloating.vue?vue&type=script&lang=js&"
export * from "./DesktopFloating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports